import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProductCard.css';

const ProductCard = ({ productKey, icon, gradient }) => {
  const { t } = useTranslation();
  const product = t(`products.${productKey}`, { returnObjects: true });

  return (
    <div className="product-card card">
      <div className="product-header">
        <div className={`product-icon ${gradient}`}>
          {icon}
        </div>
        <h3 className="product-title">{product.title}</h3>
        <p className="product-subtitle">{product.subtitle}</p>
      </div>
      
      <div className="product-features">
        {product.features.map((feature, index) => (
          <div key={index} className="feature-item">
            <div className="feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9,11 12,14 22,4"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
            </div>
            <div className="feature-content">
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="product-cta">
        <a 
          href={product.url || `#${productKey}`} 
          className="btn btn-primary"
          target={product.url ? "_blank" : "_self"}
          rel={product.url ? "noopener noreferrer" : ""}
        >
          {product.cta}
        </a>
      </div>
    </div>
  );
};

export default ProductCard; 